import React, { useState, useRef, useCallback } from 'react';

const LENS_SIZE = 220; //tamaño del círculo de la lupa
const ZOOM = 2; //esto hace que la imagen se amplie 2.2 veces

/**
 * Imagen con lupa: al pasar el cursor se ve la zona bajo el ratón ampliada en un círculo.
 */
function ImageWithLupa({ src, alt, caption }) {
  const [lens, setLens] = useState({ show: false, x: 0, y: 0, bgPosX: 0, bgPosY: 0, bgW: 0, bgH: 0 });
  const imgRef = useRef(null);

  const handleMouseMove = useCallback(
    (e) => {
      const img = imgRef.current;
      if (!img) return;
      const rect = img.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      if (x < 0 || y < 0 || x > rect.width || y > rect.height) {
        setLens((prev) => ({ ...prev, show: false }));
        return;
      }
      const w = rect.width;
      const h = rect.height;
      const bgW = w * ZOOM;
      const bgH = h * ZOOM;
      setLens({
        show: true,
        x: e.clientX - LENS_SIZE / 2,
        y: e.clientY - LENS_SIZE / 2,
        bgPosX: LENS_SIZE / 2 - (x / w) * bgW,
        bgPosY: LENS_SIZE / 2 - (y / h) * bgH,
        bgW,
        bgH,
      });
    },
    []
  );

  const handleMouseLeave = useCallback(() => {
    setLens((prev) => ({ ...prev, show: false }));
  }, []);

  return (
    <figure className="ImageWithLupa-figure" style={{ textAlign: 'center', margin: '2em 0' }}>
      <div
        className="ImageWithLupa-wrap"
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        <img
          ref={imgRef}
          src={src}
          alt={alt}
          className="ImageWithLupa-img"
        />
        {lens.show && (
          <div
            className="ImageWithLupa-lens"
            style={{
              left: lens.x,
              top: lens.y,
              width: LENS_SIZE,
              height: LENS_SIZE,
              backgroundImage: `url(${src})`,
              backgroundSize: `${lens.bgW}px ${lens.bgH}px`,
              backgroundPosition: `${lens.bgPosX}px ${lens.bgPosY}px`,
            }}
            aria-hidden
          />
        )}
      </div>
      {caption && (
        <figcaption style={{ fontSize: '0.85em', opacity: 0.8, marginTop: '0.5em', fontStyle: 'italic' }}>
          {caption}
        </figcaption>
      )}
    </figure>
  );
}

export default ImageWithLupa;
